export const name = "ST_ASGEOJSON";
export const summary = `Converts a \`GEOGRAPHY\` value to a \`STRING\` GeoJSON geography value.`;
export const reference = `
## ST_ASGEOJSON

Converts a \`GEOGRAPHY\` value to a \`STRING\` GeoJSON geography value.

\`\`\`
ST_ASGEOJSON(geography_expression)
\`\`\`

### Description

Returns the RFC 7946 compliant GeoJSONrepresentation of the input \`GEOGRAPHY\`.

A GoogleSQL \`GEOGRAPHY\` has spherical geodesic edges, whereas a GeoJSON \`Geometry\` object explicitly has planar edges. To convert between these two types of edges, GoogleSQL adds additional points to the line where necessary so that the resulting sequence of edges remains within 10 meters of the original edge.

See \`ST_GEOGFROMGEOJSON\` to construct a\`GEOGRAPHY\` from GeoJSON.


### Return type

\`STRING\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
